<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item"
    @click="$emit('click')"
  >
    <q-item-section
      v-if="withDate"
      side
      class="relative-position"
    >
      <date :date="report.report_date" />
    </q-item-section>
    <q-item-section>
      <q-item-label>
        <span
          v-if="report.address"
          class="q-mr-xs module-name"
          :class="{'text-red-8': !report.can_publish}"
        >{{ report.address.full_address }}</span>
        <small>({{ truncateString(report.reference_id, 20) }})</small>
      </q-item-label>
      <q-item-label
        v-if="report.template"
        caption
      >
        {{ report.template.title }} <span v-if="report.template.standard">({{ report.template.standard }})</span>
      </q-item-label>
      <Status
        v-if="withStatus"
        flat
        :report="report"
        class="q-mt-sm"
        :class="{'lt-sm': withStatus}"
      />
    </q-item-section>
    <q-item-section
      v-if="withStatus"
      side
      style="min-width: 85px;"
      class="q-pl-sm gt-xs"
    >
      <Status :report="report" />
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
      @click.stop
    >
      <slot />
    </q-item-section>
  </q-item>
</template>

<script>
import Status from './Status'
import itemMixin from 'src/helpers/item'

/*
  Partial to display report information on any page
*/
export default {
  components: {
    Status
  },
  mixins: [itemMixin],
  props: {
    report: {
      required: true,
      type: Object
    },
    withStatus: {
      type: Boolean,
      default: true
    },
    withDate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>
